import { UncategorizedPriorityFeatures } from '../../../../v2/components/merch-card/feature-display/UncategorizedPriorityFeatures';
import SkeletonLoadWrapper from '../../../common/loading/SkeletonLoadWrapper';
import { getI18nKeyOverrideForProductCard } from '../../I18nUtils';
import { usePriorityFeaturesForApiNameHideFromLang } from '../useFeatures';
import { jsx as _jsx } from "react/jsx-runtime";
export const ProductTileFeaturesContainer = ({
  apiName,
  isCollapsible = false
}) => {
  var _getI18nKeyOverrideFo;
  const {
    loading,
    priorityFeatures
  } = usePriorityFeaturesForApiNameHideFromLang({
    productApiName: apiName
  });
  const lowerTierPlus = (_getI18nKeyOverrideFo = getI18nKeyOverrideForProductCard(apiName)) === null || _getI18nKeyOverrideFo === void 0 ? void 0 : _getI18nKeyOverrideFo.lowerTierPlus;
  return /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
    isLoading: loading,
    heights: [48, 48],
    widths: ['100%', '100%'],
    children: priorityFeatures.length ? /*#__PURE__*/_jsx(UncategorizedPriorityFeatures, {
      uncategorizedFeatures: priorityFeatures,
      lowerTierMessage: lowerTierPlus,
      isCollapsible: isCollapsible
    }) : null
  });
};